import { TransactionDetails } from "@merchant_api/models/transaction-details";

export class TransactionSiblingsState {
    loading = false;
    error = null;
    record: Array<TransactionDetails> = [];
}
